export const translations = {
  en: {
    "nav.parties": "Parties",
    "nav.clubs": "Speaking clubs",
    "nav.about": "About",
    "hero.eyebrow": "KNDLA® — nights, words, flame",
    "hero.line1": "PARTIES THAT",
    "hero.line2": "SPEAK",
    "hero.line3": "LOUDER.",
    "hero.sub": "We bring people together through parties and speaking clubs. Come for the conversation — stay for the party.",
    "hero.ctaParties": "See the next parties",
    "hero.ctaClubs": "Explore speaking clubs",
    "hero.scroll": "Scroll",
    "marquee.parties": "PARTIES",
    "marquee.clubs": "SPEAKING CLUBS",
    "marquee.spanish": "SPANISH",
    "marquee.english": "ENGLISH",
    "marquee.portuguese": "PORTUGUESE",
    "parties.eyebrow": "01 — Nights",
    "parties.title": "Upcoming parties",
    "parties.sub": "Pick a night, choose how many spots, and we sort the payment with you on Telegram. No accounts, no queues.",
    "parties.spots": "{n} spots",
    "parties.free": "Free",
    "parties.getTickets": "Get tickets",
    "parties.empty": "New nights are being cooked up. Follow us on Telegram to hear first.",
    "modal.howMany": "How many?",
    "modal.total": "Total",
    "modal.pay": "Pay via Telegram",
    "modal.note": "You'll land in our Telegram (@{handle}) with your order pre-written — we confirm your spots and share the transfer details there.",
    "modal.botNote": "The official KNDLA bot will open this event with your selected quantity. The bot confirms the final price and payment details.",
    "parties.unavailable": "Tickets not available",
    "modal.less": "One less ticket",
    "modal.more": "One more ticket",
    "clubs.eyebrow": "02 — Words",
    "clubs.title": "Speaking clubs",
    "clubs.sub": "Free conversation nights in bars, not classrooms. Show up, order a drink, speak another language for two hours. Tap a date to save your spot on Telegram.",
    "clubs.freeEntry": "Free entry",
    "clubs.note": "Spots are limited — clubs fill fast after parties",
    "clubs.empty": "Next club dates are being scheduled — check back soon.",
    "about.eyebrow": "03 — The idea",
    "about.titleA": "KNDLA is where ",
    "about.titleB": "different cultures",
    "about.titleC": " meet on ",
    "about.titleD": "the dancefloor",
    "about.titleE": ". And keep talking after.",
    "about.body": "Good nights bring people together: the conversation at 2am, a new friend, a song that everyone knows. We create places for people to meet through music, parties and conversation.",
    "about.stat1": "Languages on rotation",
    "about.stat2": "Parties every year",
    "about.stat3": "Community, zero snobbery",
    "footer.tagline": "Parties and speaking clubs. Come for the conversation, stay for the party.",
    "footer.explore": "Explore",
    "footer.linkParties": "Upcoming parties",
    "footer.linkClubs": "Speaking clubs",
    "footer.linkAbout": "About KNDLA",
    "footer.findUs": "Find us",
    "footer.channel": "Telegram channel — @KNDLA404",
    "footer.rights": "© 2026 KNDLA — All flames reserved.",
  },
  es: {
    "nav.parties": "Fiestas",
    "nav.clubs": "Clubs de conversación",
    "nav.about": "Nosotros",
    "hero.eyebrow": "KNDLA® — noches, palabras, fuego",
    "hero.line1": "FIESTAS QUE",
    "hero.line2": "HABLAN",
    "hero.line3": "MÁS FUERTE.",
    "hero.sub": "Reunimos a personas de distintas culturas a través de fiestas y clubs de conversación. Ven por la conversación — quédate por la fiesta.",
    "hero.ctaParties": "Ver próximas fiestas",
    "hero.ctaClubs": "Ver clubs de conversación",
    "hero.scroll": "Desliza",
    "marquee.parties": "FIESTAS",
    "marquee.clubs": "CLUBS DE CONVERSACIÓN",
    "marquee.spanish": "ESPAÑOL",
    "marquee.english": "INGLÉS",
    "marquee.portuguese": "PORTUGUÉS",
    "parties.eyebrow": "01 — Noches",
    "parties.title": "Próximas fiestas",
    "parties.sub": "Elige una noche, cuántas entradas quieres, y cerramos el pago contigo por Telegram. Sin cuentas, sin colas.",
    "parties.spots": "{n} plazas",
    "parties.free": "Gratis",
    "parties.getTickets": "Entradas",
    "parties.empty": "Estamos cocinando nuevas noches. Síguenos en Telegram para enterarte primero.",
    "modal.howMany": "¿Cuántas?",
    "modal.total": "Total",
    "modal.pay": "Pagar por Telegram",
    "modal.note": "Entrarás en nuestro Telegram (@{handle}) con tu pedido ya escrito — confirmamos tus entradas y te pasamos los datos para la transferencia.",
    "modal.botNote": "El bot oficial abrirá esta fiesta con la cantidad elegida. Allí confirmarás el precio final y los datos de pago.",
    "parties.unavailable": "Entradas no disponibles",
    "modal.less": "Una entrada menos",
    "modal.more": "Una entrada más",
    "clubs.eyebrow": "02 — Palabras",
    "clubs.title": "Clubs de conversación",
    "clubs.sub": "Noches de conversación gratis en bares, no en aulas. Ven, pide una copa y habla otro idioma durante dos horas. Toca una fecha para reservar tu sitio por Telegram.",
    "clubs.freeEntry": "Entrada gratis",
    "clubs.note": "Plazas limitadas — los clubs se llenan rápido después de las fiestas",
    "clubs.empty": "Estamos cerrando las próximas fechas — vuelve pronto.",
    "about.eyebrow": "03 — La idea",
    "about.titleA": "KNDLA es donde ",
    "about.titleB": "distintas culturas",
    "about.titleC": " se encuentran en ",
    "about.titleD": "la pista de baile",
    "about.titleE": ". Y siguen conversando después.",
    "about.body": "Las mejores noches reúnen personas: una conversación a las dos de la mañana, un nuevo amigo, una canción que todos conocen. Organizamos fiestas y encuentros para conectar a través de la música y la conversación.",
    "about.stat1": "Idiomas en rotación",
    "about.stat2": "Fiestas cada año",
    "about.stat3": "Comunidad, cero postureo",
    "footer.tagline": "Fiestas y clubs de conversación. Ven por la conversación, quédate por la fiesta.",
    "footer.explore": "Explora",
    "footer.linkParties": "Próximas fiestas",
    "footer.linkClubs": "Clubs de conversación",
    "footer.linkAbout": "Sobre KNDLA",
    "footer.findUs": "Encuéntranos",
    "footer.channel": "Canal de Telegram — @KNDLA404",
    "footer.rights": "© 2026 KNDLA — Todas las llamas reservadas.",
  },
  ru: {
    "nav.parties": "Вечеринки",
    "nav.clubs": "Разговорные клубы",
    "nav.about": "О нас",
    "hero.eyebrow": "KNDLA® — ночи, слова, огонь",
    "hero.line1": "ВЕЧЕРИНКИ,",
    "hero.line2": "КОТОРЫЕ",
    "hero.line3": "ГРОМЧЕ ВСЕХ.",
    "hero.sub": "Мы объединяем людей из разных культур на вечеринках и в разговорных клубах. Приходи ради общения — оставайся ради вечеринки.",
    "hero.ctaParties": "Ближайшие вечеринки",
    "hero.ctaClubs": "Разговорные клубы",
    "hero.scroll": "Листай",
    "marquee.parties": "ВЕЧЕРИНКИ",
    "marquee.clubs": "РАЗГОВОРНЫЕ КЛУБЫ",
    "marquee.spanish": "ИСПАНСКИЙ",
    "marquee.english": "АНГЛИЙСКИЙ",
    "marquee.portuguese": "ПОРТУГАЛЬСКИЙ",
    "parties.eyebrow": "01 — Ночи",
    "parties.title": "Ближайшие вечеринки",
    "parties.sub": "Выбери ночь и количество мест — оплату решим с тобой в Telegram. Без аккаунтов и очередей.",
    "parties.spots": "{n} мест",
    "parties.free": "Бесплатно",
    "parties.getTickets": "Билеты",
    "parties.empty": "Готовим новые ночи. Подпишись на Telegram, чтобы узнать первым.",
    "modal.howMany": "Сколько?",
    "modal.total": "Итого",
    "modal.pay": "Оплатить в Telegram",
    "modal.note": "Ты попадёшь в наш Telegram (@{handle}) с уже написанным заказом — подтвердим места и отправим реквизиты для перевода.",
    "modal.botNote": "Официальный бот откроет эту вечеринку с выбранным количеством билетов. Цена и оплата подтверждаются в боте.",
    "parties.unavailable": "Билеты недоступны",
    "modal.less": "На один билет меньше",
    "modal.more": "На один билет больше",
    "clubs.eyebrow": "02 — Слова",
    "clubs.title": "Разговорные клубы",
    "clubs.sub": "Бесплатные разговорные вечера в барах, а не в классах. Приходи, закажи напиток и говори два часа на другом языке. Нажми на дату, чтобы занять место через Telegram.",
    "clubs.freeEntry": "Вход свободный",
    "clubs.note": "Мест мало — после вечеринок клубы заполняются быстро",
    "clubs.empty": "Новые даты скоро появятся — загляни позже.",
    "about.eyebrow": "03 — Идея",
    "about.titleA": "KNDLA — место, где ",
    "about.titleB": "разные культуры",
    "about.titleC": " встречаются на ",
    "about.titleD": "танцполе",
    "about.titleE": ". И продолжают общаться после вечеринки.",
    "about.body": "Лучшие вечера объединяют людей: разговор в два часа ночи, новый друг, знакомая всем песня. Мы организуем вечеринки и встречи, чтобы люди знакомились через музыку и общение.",
    "about.stat1": "Языка в ротации",
    "about.stat2": "Вечеринок в год",
    "about.stat3": "Тусовка без пафоса",
    "footer.tagline": "Вечеринки и разговорные клубы. Приходи ради общения, оставайся ради вечеринки.",
    "footer.explore": "Разделы",
    "footer.linkParties": "Ближайшие вечеринки",
    "footer.linkClubs": "Разговорные клубы",
    "footer.linkAbout": "О KNDLA",
    "footer.findUs": "Мы на связи",
    "footer.channel": "Telegram-канал — @KNDLA404",
    "footer.rights": "© 2026 KNDLA — Все огни защищены.",
  },
};

export const LOCALES = { en: "en-GB", es: "es-ES", ru: "ru-RU" };
